'use client';

import React from 'react';
import { type LayoutProps } from './layout.type';
import { Header, StartScreenWeb } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { ONBOARDING } from '$locale/constants';
import { START_SCREEN_ARRAY_LENGTH, START_SCREEN_IMAGE_URL } from '$modules/onboarding/constants/layout';
import styles from './layout.module.scss';
import useGlobalContext from '$hooks/use-global-context';
const LayoutWeb: React.FC<LayoutProps> = ({
  children
}) => {
  const {
    t
  } = useLocale(ONBOARDING);
  const {
    state
  } = useGlobalContext();
  const coBrandCarousalData = state?.coBrandDetails?.carousal;
  const isLoaded = state?.coBrandDetails?.isLoaded;
  let coBrandImageArray: string[] = [];
  let coBrandHeadingArray: string[] = [];
  let coBrandTextArray: string[] = [];
  if (isLoaded) {
    if (coBrandCarousalData?.length) {
      coBrandCarousalData.forEach((data: any) => {
        coBrandImageArray.push(data.imageUrl);
        coBrandHeadingArray.push(data.heading);
        coBrandTextArray.push(data.text);
      });
    } else {
      coBrandImageArray = [`${START_SCREEN_IMAGE_URL}/startScreenOne.png`, `${START_SCREEN_IMAGE_URL}/startScreenTwo.png`, `${START_SCREEN_IMAGE_URL}/startScreenThree.png`];
      coBrandTextArray = Array.from(Array(START_SCREEN_ARRAY_LENGTH)).map((_, index) => t(`startScreen.applicantTextArray.${index}`));
      coBrandHeadingArray = Array.from(Array(START_SCREEN_ARRAY_LENGTH)).map((_, index) => t(`startScreen.applicantHeadingArray.${index}`));
    }
  }
  return <>
      <div className={styles.onboardingLayout}>
        <div className={styles.layoutSubContainer}>
          <Header coBrandLogo={state?.coBrandDetails?.logo} coBrandText={t('startScreen.poweredBy')} data-sentry-element="Header" data-sentry-source-file="layout.web.tsx" />
          <StartScreenWeb textArray={coBrandTextArray} headingArray={coBrandHeadingArray} imageArray={coBrandImageArray} data-sentry-element="StartScreenWeb" data-sentry-source-file="layout.web.tsx" />
        </div>
        <div className={styles.layoutSubContainer}>{children}</div>
      </div>
    </>;
};
export default LayoutWeb;